import { Button, Chip, Stack } from '@mui/material';
import type { AppliedFilter } from '@/features/operations/catalogQuery';

/**
 * The filters in force, one removable tag per value. On a phone the row scrolls sideways instead
 * of growing, so the results stay in view.
 */
export function AppliedFilterChips({
  filters,
  onRemove,
  onClear,
}: {
  filters: AppliedFilter[];
  onRemove: (filter: AppliedFilter) => void;
  onClear: () => void;
}) {
  if (!filters.length) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      aria-label="Filtros aplicados"
      sx={{
        flexWrap: { xs: 'nowrap', md: 'wrap' },
        overflowX: { xs: 'auto', md: 'visible' },
        rowGap: 1,
        pb: { xs: 0.5, md: 0 },
      }}
    >
      {filters.map((filter) => (
        // The whole tag removes the filter, and its name says so; the cross is only a visual cue.
        <Chip
          key={filter.key}
          label={filter.label}
          onClick={() => onRemove(filter)}
          onDelete={() => onRemove(filter)}
          aria-label={`Quitar filtro: ${filter.label}`}
          variant="outlined"
          sx={{ flexShrink: 0 }}
        />
      ))}
      <Button
        size="small"
        color="inherit"
        onClick={onClear}
        sx={{ flexShrink: 0, textDecoration: 'underline' }}
      >
        Limpiar filtros
      </Button>
    </Stack>
  );
}
